import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { CartPoLineService } from './core/cart-po-line.service';
import { isEmpty } from '../../../../../../core/services/simple-tools';
import { CustomActiveCartService } from '../../../_core/active-cart.service';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';

@Component({
  selector: 'cart-po-line',
  templateUrl: './cart-po-line.component.html',
  styleUrl: './cart-po-line.component.scss',
  standalone: false,
})
export class CartPoLineComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  emptyCart$ = new BehaviorSubject<boolean>(false);
  form: UntypedFormGroup = this.fb.group({
    poLine: [false],
  });

  constructor(
    protected fb: UntypedFormBuilder,
    private cartPoLineService: CartPoLineService,
    private activeCartService: CustomActiveCartService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.populate();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  populate() {
    this.subscription.add(
      this.activeCartService.getActive().subscribe(data => {
        this.emptyCart$.next((data.entries || [])?.length === 0);
        const hasPoLineNumber = data?.entries?.find(entry => !isEmpty(entry.poLine)) !== undefined;

        this.form.get('poLine')?.setValue(hasPoLineNumber);
        this.cartPoLineService.set(hasPoLineNumber);
      }),
    );
  }

  onChange(checked: boolean) {
    this.cartPoLineService.set(checked);

    if (!checked) {
      this.activeCartService
        .clearPoLines()
        .pipe(take(1))
        .subscribe(data => {
          if (data.hasError) {
            this.toasterService.init({
              type: TOASTER_TYPE.DANGER,
              content: data.message || '',
            });
          } else {
            this.activeCartService.reloadActiveCart();
          }
        });
    }
  }
}
